<template>
  <header
    class="w-full fixed top-0 left-0 z-50 transition-all duration-300"
    :class="scrolled ? 'bg-white shadow-[0_2px_8px_rgba(0,0,0,0.1)]' : 'bg-transparent'"
  >

    <!-- Desktop Header (lg and above) -->
    <div class="hidden lg:flex items-center justify-between px-8 h-20">

      <!-- Logo -->
      <div class="flex items-center">
        <img
          src="@/assets/vectolabs-logo.png"
          alt="Vectolabs"
          class="h-auto w-50"
        />
      </div>

      <!-- Nav -->
      <nav class="flex items-center text-lg font-medium text-neutral-700">

        <router-link
          to="/"
          class="transition duration-250 ease-in-out hover:text-primary px-8"
          exact-active-class=""
        >
          HOME
        </router-link>

        <!-- PRODUCT -->
        <div
          class="relative"
          @mouseenter="desktopProductOpen = true"
          @mouseleave="desktopProductOpen = false"
        >
          <button
            class="flex items-center gap-1 transition duration-250 ease-in-out px-8 py-2 hover:text-primary"
            :class="isProductActive ? '' : ''"
          >
            PRODUCT
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div v-show="desktopProductOpen" class="absolute left-0 bg-neutral-200 shadow-lg rounded-md min-w-50">
            <router-link
              to="/smart-city-solution"
              class="text-xs block px-6 py-4 hover:bg-neutral-400 hover:text-white"
              active-class="bg-neutral-400 text-white"
            >
              SMART CITY SOLUTION
            </router-link>
            <router-link
              to="/enterprise-iot-solutions"
              class="text-xs block px-6 py-4 hover:bg-neutral-400 hover:text-white"
              active-class="bg-neutral-400 text-white"
            >
            ENTERPRISE IOT SOLUTION
            </router-link>
          </div>
        </div>

        <!-- ABOUT US -->
        <div
          class="relative"
          @mouseenter="desktopAboutOpen = true"
          @mouseleave="desktopAboutOpen = false"
        >
          <button
            class="flex items-center gap-1 transition duration-250 ease-in-out px-8 py-2 hover:text-primary"
            :class="isAboutActive ? '' : ''"
          >
            ABOUT US
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div v-show="desktopAboutOpen" class="absolute text-xs left-0 bg-neutral-200 shadow-lg rounded-md min-w-60">
            <router-link
              to="/organizational-chart"
              class="block px-6 py-4 hover:bg-neutral-400 hover:text-white border-b border-white"
              active-class="bg-neutral-400 text-white"
            >
              ORGANIZATIONAL CHART
            </router-link>
            <router-link
              to="/pdpp"
              class="block px-6 py-4 hover:bg-neutral-400 hover:text-white border-b border-white"
              active-class="bg-neutral-400 text-white"
            >
              PERSONAL DATA PROTECTION POLICY
            </router-link>
            <router-link
              to="/hse-statement"
              class="block px-6 py-4 hover:bg-neutral-400 hover:text-white border-b border-white"
              active-class="bg-neutral-400 text-white"
            >
              HSE STATEMENT
            </router-link>
            <router-link
              to="/company-activities"
              class="block px-6 py-4 hover:bg-neutral-400 hover:text-white border-b border-white"
              active-class="bg-neutral-400 text-white"
            >
              COMPANY ACTIVITIES
            </router-link>
          </div>
        </div>

        <!--
        <a href="#" class="transition duration-250 ease-in-out hover:text-primary px-8 py-2">PRESS RELEASE</a>
        -->
        <router-link
          to="/contact-us"
          class="transition duration-250 ease-in-out hover:text-primary px-8 py-2"
          active-class=""
        >
          CONTACT US
        </router-link>

      </nav>
    </div>

    <!-- Mobile/Tablet Header bar (below lg) -->
    <div class="flex lg:hidden items-center justify-between px-5 h-16 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
      <img src="@/assets/vectolabs-logo.png" alt="Vectolabs" class="h-8 w-auto max-w-50 object-contain" />

      <button @click="menuOpen = true" class="p-2 text-neutral-700" aria-label="Open menu">
        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 6h18M3 12h18M3 18h18" />
        </svg>
      </button>
    </div>

  </header>

  <!-- Drawer Overlay -->
  <div
    v-if="menuOpen"
    @click="menuOpen = false"
    class="fixed inset-0 bg-black/40 z-50 lg:hidden"
  ></div>

  <!-- Right-side Drawer -->
  <div
    class="fixed top-0 right-0 h-full w-72 bg-black z-50 shadow-2xl flex flex-col transition-transform duration-300 ease-in-out lg:hidden"
    :class="menuOpen ? 'translate-x-0' : 'translate-x-full'"
  >

    <!-- Drawer Header -->
    <div class="flex items-center justify-end px-4 h-16 border-b border-white/10 shrink-0">
      <button
        @click="menuOpen = false"
        aria-label="Close menu"
        class="p-2 text-white hover:text-primary"
      >
        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Drawer Nav -->
    <nav class="flex flex-col text-white font-medium overflow-y-auto flex-1">

      <router-link
        to="/"
        @click="menuOpen = false"
        class="block px-6 py-4 border-b border-white/10 hover:text-primary"
        exact-active-class="text-primary"
      >
        HOME
      </router-link>

      <!-- PRODUCT -->
      <div>
        <div class="flex items-center border-b border-white/10">
          <a href="#" class="flex-1 px-6 py-4 hover:text-primary">PRODUCT</a>
          <button
            @click="productOpen = !productOpen"
            class="px-4 py-4 hover:text-primary"
            aria-label="Toggle product submenu"
          >
            <svg class="w-4 h-4 transition-transform duration-200" :class="productOpen ? 'rotate-180' : ''" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </div>
        <div v-if="productOpen" class="bg-white/5 text-sm">
          <router-link
            to="/smart-city-solution"
            @click="menuOpen = false"
            class="block px-8 py-3 border-b border-white/10 hover:text-primary"
            active-class="text-primary"
          >
            SMART CITY SOLUTION
          </router-link>
        </div>
      </div>

      <!-- ABOUT US -->
      <div>
        <div class="flex items-center border-b border-white/10">
          <a href="#" class="flex-1 px-6 py-4 hover:text-primary">ABOUT US</a>
          <button
            @click="aboutOpen = !aboutOpen"
            class="px-4 py-4 hover:text-primary"
            aria-label="Toggle about us submenu"
          >
            <svg class="w-4 h-4 transition-transform duration-200" :class="aboutOpen ? 'rotate-180' : ''" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
        </div>
        <div v-if="aboutOpen" class="bg-white/5 text-sm">
          <router-link
            to="/organizational-chart"
            @click="menuOpen = false"
            class="block px-8 py-3 border-b border-white/10 hover:text-primary"
            active-class="text-primary"
          >
            ORGANIZATIONAL CHART
          </router-link>
          <router-link
            to="/pdpp"
            @click="menuOpen = false"
            class="block px-8 py-3 border-b border-white/10 hover:text-primary"
            active-class="text-primary"
          >
            PERSONAL DATA PROTECTION POLICY
          </router-link>
          <router-link
            to="/hse-statement"
            @click="menuOpen = false"
            class="block px-8 py-3 border-b border-white/10 hover:text-primary"
            active-class="text-primary"
          >
            HSE STATEMENT
          </router-link>
          <router-link
            to="/company-activities"
            @click="menuOpen = false"
            class="block px-8 py-3 border-b border-white/10 hover:text-primary"
            active-class="text-primary"
          >
            COMPANY ACTIVITIES
          </router-link>
        </div>
      </div>

      <!--
      <a href="#" class="block px-6 py-4 border-b border-white/10 hover:text-primary">PRESS RELEASE</a>
      -->

      <router-link
        to="/contact-us"
        @click="menuOpen = false"
        class="block px-6 py-4 border-b border-white/10 hover:text-primary"
        active-class="text-primary"
      >
        CONTACT US
      </router-link>

    </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    scrolled: Boolean,
  },
  data() {
    return {
      menuOpen: false,
      productOpen: false,
      aboutOpen: false,
      desktopProductOpen: false,
      desktopAboutOpen: false,
    };
  },
  computed: {
    isProductActive() {
      return ['/smart-city-solution'].includes(this.$route.path)
    },
    isAboutActive() {
      return ['/organizational-chart', '/pdpp', '/hse-statement', '/company-activities'].includes(this.$route.path)
    }
  },
  watch: {
    $route() {
      this.desktopProductOpen = false
      this.desktopAboutOpen = false
    }
  },
};
</script>
